type IconProps = {
  color?: string;
  backgroundColor?: string;
  size?: number;
  className?: string;
};

export function IconPOForNav({
  className,
}: {
  className?: string;
}) {
  return (
    <IconPO className={className} color="currentColor" size={20} />
  );
}

export function IconPO({
  color = "white",
  backgroundColor,
  size = 26,
  className,
}: IconProps) {
  const bgColor = backgroundColor || color;

  return (
    <svg
      width={size}
      height={size}
      className={className}
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.4">
        <path
          d="M8.76635 1.86115C8.96694 1.75895 9.22216 1.69426 9.64028 1.6601C10.0647 1.62542 10.6077 1.625 11.375 1.625H14.625C15.3923 1.625 15.9353 1.62542 16.3597 1.6601C16.7778 1.69426 17.0331 1.75895 17.2336 1.86115C17.6413 2.06888 17.9728 2.40034 18.1805 2.80802C18.2827 3.00861 18.3474 3.26382 18.3816 3.68195C18.4162 4.10639 18.4167 4.64932 18.4167 5.41667V8.66667C18.4167 9.43401 18.4162 9.97694 18.3816 10.4014C18.3474 10.8195 18.2827 11.0747 18.1805 11.2753C17.9728 11.683 17.6413 12.0145 17.2336 12.2222C17.0331 12.3244 16.7778 12.3891 16.3597 12.4232C15.9353 12.4579 15.3923 12.4583 14.625 12.4583H11.375C10.6077 12.4583 10.0647 12.4579 9.64028 12.4232C9.22216 12.3891 8.96694 12.3244 8.76635 12.2222C8.35867 12.0145 8.02721 11.683 7.81949 11.2753C7.71728 11.0747 7.6526 10.8195 7.61843 10.4014C7.58375 9.97694 7.58333 9.43401 7.58333 8.66667V5.41667C7.58333 4.64932 7.58375 4.10639 7.61843 3.68195C7.6526 3.26382 7.71728 3.00861 7.81949 2.80802C8.02721 2.40034 8.35867 2.06888 8.76635 1.86115Z"
          fill={bgColor}
        />
        <path
          d="M12.4583 17.3333V20.5833C12.4583 21.3507 12.4579 21.8936 12.4232 22.3181C12.3891 22.7362 12.3244 22.9914 12.2222 23.192C12.0145 23.5997 11.683 23.9311 11.2753 24.1388C11.0747 24.2411 10.8195 24.3057 10.4014 24.3399C9.97694 24.3746 9.43401 24.375 8.66667 24.375H5.41667C4.64932 24.375 4.10639 24.3746 3.68195 24.3399C3.26382 24.3057 3.00861 24.2411 2.80802 24.1388C2.40034 23.9311 2.06888 23.5997 1.86115 23.192C1.75895 22.9914 1.69426 22.7362 1.6601 22.3181C1.62542 21.8936 1.625 21.3507 1.625 20.5833V17.3333C1.625 16.566 1.62542 16.0231 1.6601 15.5986C1.69426 15.1805 1.75895 14.9253 1.86115 14.7247C2.06888 14.317 2.40034 13.9855 2.80802 13.7778C3.00861 13.6756 3.26382 13.6109 3.68195 13.5768C4.10639 13.5421 4.64932 13.5417 5.41667 13.5417H8.66667C9.43401 13.5417 9.97694 13.5421 10.4014 13.5768C10.8195 13.6109 11.0747 13.6756 11.2753 13.7778C11.683 13.9855 12.0145 14.317 12.2222 14.7247C12.3244 14.9253 12.3891 15.1805 12.4232 15.5986C12.4579 16.0231 12.4583 16.566 12.4583 17.3333Z"
          fill={bgColor}
        />
        <path
          d="M13.5768 22.3181C13.5421 21.8936 13.5417 21.3507 13.5417 20.5833V17.3333C13.5417 16.566 13.5421 16.0231 13.5768 15.5986C13.6109 15.1805 13.6756 14.9253 13.7778 14.7247C13.9855 14.317 14.317 13.9855 14.7247 13.7778C14.9253 13.6756 15.1805 13.6109 15.5986 13.5768C16.0231 13.5421 16.566 13.5417 17.3333 13.5417H20.5833C21.3507 13.5417 21.8936 13.5421 22.3181 13.5768C22.7362 13.6109 22.9914 13.6756 23.192 13.7778C23.5997 13.9855 23.9311 14.317 24.1388 14.7247C24.2411 14.9253 24.3057 15.1805 24.3399 15.5986C24.3746 16.0231 24.375 16.566 24.375 17.3333V20.5833C24.375 21.3507 24.3746 21.8936 24.3399 22.3181C24.3057 22.7362 24.2411 22.9914 24.1388 23.192C23.9311 23.5997 23.5997 23.9311 23.192 24.1388C22.9914 24.2411 22.7362 24.3057 22.3181 24.3399C21.8936 24.3746 21.3507 24.375 20.5833 24.375H17.3333C16.566 24.375 16.0231 24.3746 15.5986 24.3399C15.1805 24.3057 14.9253 24.2411 14.7247 24.1388C14.317 23.9311 13.9855 23.5997 13.7778 23.192C13.6756 22.9914 13.6109 22.7362 13.5768 22.3181Z"
          fill={bgColor}
        />
      </g>
      <path
        d="M10.6165 1.62684V7.04059C10.6165 7.27329 10.8906 7.39765 11.0657 7.24442L12.8215 5.7081C12.9236 5.61875 13.076 5.61875 13.1781 5.70809L14.934 7.24444C15.1091 7.39767 15.3832 7.27331 15.3832 7.04062V1.62683C15.1571 1.62506 14.9062 1.625 14.6251 1.625H11.3751C11.0938 1.625 10.8427 1.62506 10.6165 1.62684Z"
        fill={color}
      />
      <path
        d="M4.6582 13.5435V18.9573C4.6582 19.19 4.93227 19.3143 5.10738 19.1611L6.86312 17.6248C6.96523 17.5354 7.1177 17.5354 7.21981 17.6248L8.97569 19.1611C9.15081 19.3143 9.42487 19.19 9.42487 18.9573V13.5435C9.1988 13.5417 8.94783 13.5417 8.66675 13.5417H5.41675C5.13549 13.5417 4.88438 13.5417 4.6582 13.5435Z"
        fill={color}
      />
      <path
        d="M16.5749 13.5435V18.9573C16.5749 19.19 16.8489 19.3143 17.0241 19.1611L18.7798 17.6248C18.8819 17.5354 19.0344 17.5354 19.1365 17.6248L20.8924 19.1611C21.0675 19.3143 21.3415 19.19 21.3415 18.9573V13.5435C21.1155 13.5417 20.8645 13.5417 20.5834 13.5417H17.3334C17.0522 13.5417 16.801 13.5417 16.5749 13.5435Z"
        fill={color}
      />
    </svg>
  );
}
